import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

interface OpenTicketBucketsProps {
  buckets: {
    lessThan1Hour: number;
    lessThan1Day: number;
    lessThan3Days: number;
    lessThan7Days: number;
    moreThan7Days: number;
  };
}

const BUCKET_COLORS = [
  'hsl(142, 76%, 36%)', // Green - < 1h
  'hsl(47, 76%, 50%)',  // Yellow - < 1d
  'hsl(25, 76%, 50%)',  // Orange - < 3d
  'hsl(15, 76%, 50%)',  // Deep orange - < 7d
  'hsl(0, 76%, 50%)',   // Red - > 7d
];

export function OpenTicketBuckets({ buckets }: OpenTicketBucketsProps) {
  const data = [
    { name: '< 1h', value: buckets.lessThan1Hour, color: BUCKET_COLORS[0] },
    { name: '< 1d', value: buckets.lessThan1Day, color: BUCKET_COLORS[1] },
    { name: '< 3d', value: buckets.lessThan3Days, color: BUCKET_COLORS[2] },
    { name: '< 7d', value: buckets.lessThan7Days, color: BUCKET_COLORS[3] },
    { name: '> 7d', value: buckets.moreThan7Days, color: BUCKET_COLORS[4] },
  ];

  const totalOpen = data.reduce((sum, d) => sum + d.value, 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          Open Tickets by Age
          <span className="ml-2 text-sm font-normal text-muted-foreground">
            ({totalOpen} total)
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[180px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="horizontal">
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 12 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                tick={{ fontSize: 12 }}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'hsl(var(--popover))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '6px',
                }}
                labelStyle={{ color: 'hsl(var(--popover-foreground))' }}
                formatter={(value: number) => [`${value} tickets`, 'Open']}
              />
              <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
